<template>
  <div class="lp-notes-panel" style="height: 100%">
    <v-toolbar flat class="elevation-0 transparent">
      <v-toolbar-title class="subheading">Speaker notes</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon style="margin: 0;" @click="modifyFontSize(+1)">
              <v-icon>mdi-format-font-size-increase</v-icon>
            </v-btn>
          </template>
          <span>Increase font size</span>
        </v-tooltip>
        
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon style="margin: 0;" @click="modifyFontSize(-1)">
              <v-icon>mdi-format-font-size-decrease</v-icon>
            </v-btn>
          </template>
          <span>Decrease font size</span>
        </v-tooltip>

        <v-tooltip bottom v-if="canShowOpenNotesButton">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon style="margin: 0; margin-left: 16px;" @click="lessonPlanController.openSpeakerNotesWindow()">
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </template>
          <span>Open in new tab</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>

    <div
      v-if="isSpeakerNotesWindow"
      class="notes-scroll-viewer presenter-mode">
      <p-rich-text
        v-model="speakerNotes"
        :canEdit="false"
        min-height="fit-content"
        placeholder="Speaker notes..."
        :fontSize="notesFontSize" />
    </div>
    <div
      v-else-if="lessonPlanController.navigation.selectedSlide"
      v-bind:class="[isDraft && isEditMode ? 'notes-scroll-editor' : 'notes-scroll-viewer']"
    >
      <p-rich-text
        v-model="lessonPlanController.navigation.selectedSlide.notes.speaker"
        :canEdit="isEditMode"
        fixed-toolbar
        placeholder="Write speaker notes..."
        :fontSize="lessonPlanController.notesFontSize" />
    </div>
    <div v-else>
      <p class="lp-right-panel-tile-title">No slide selected</p>
    </div>
  </div>
</template>

<script>
import { PRichText } from "plant-common"
import presenterModeMixin from '../../../mixins/PresenterMode';

export default {
  inject: ["lessonPlanController"],
  mixins: [ presenterModeMixin ],
  components: { PRichText },
  props: ["contentId", "view"],
  data() {
    return {
      isSpeakerNotesWindow: false,
      speakerNotes: null,
      notesFontSize: null
    }
  },
  created() {
    if (!this.$router) return

    this.checkIsSpeakerNotesWindow()

    if (this.isSpeakerNotesWindow) {
      this.checkIsStudentWindow()

      this.initPresenterModeChannel()

      this.presenterModeChannel.postMessage({ action: this.constants.SPEAKER_NOTES_READY, contentId: this.contentId })
    }
  },
  computed: {
    isDraft() {
      if (this.$router) {
        const pathParams = this.getPathParams()
        const lastPathParam = pathParams[pathParams.length - 1]
        return lastPathParam === "draft"
      } else {
        return false
      }
    },
    isEditMode() {
      return this.lessonPlanController.mode == "edit"
    },
		isPresenterModeActive() {
			return this.isScreenSharingActive || this.isDuplicateScreenActive
		},
    canShowOpenNotesButton() {
      return !this.isSpeakerNotesWindow && this.isPresenterModeActive
    }
  },
  methods: {
    getPathParams() {
      return this.$router.app.$route.fullPath.split("/")
    },
    checkIsSpeakerNotesWindow() {
      const pathParams = this.getPathParams()
      if (pathParams.includes("speaker-notes")) this.isSpeakerNotesWindow = true
    },
    checkIsStudentWindow() {
      if (this.view === "student") this.setStudentWindowActive(true)
    },
    modifyFontSize(value) {
      if (this.isSpeakerNotesWindow) {
        this.presenterModeChannel.postMessage({
          action: this.constants.UPDATE_FONT_SIZE_NOTES_WINDOW,
          fontSize: this.notesFontSize += value,
          contentId: this.contentId,
          isStudentWindow: this.isStudentWindowActive
        });
      } else {
        this.lessonPlanController.modifyFontSize(value)
      }
    },
    handlePresenterModeChannelEvents() {
      this.presenterModeChannel.onmessage = (event) => {
        const { action, contentId: id, notes, fontSize, isStudentWindow } = event.data

        if (this.contentId !== id) return

        if (action === this.constants.UPDATE_SPEAKER_NOTES) {          
          this.speakerNotes = notes
        }


        if (action === this.constants.UPDATE_FONT_SIZE_NOTES && this.isStudentWindowActive === isStudentWindow) {
          this.notesFontSize = fontSize
        }
      }
    }
  },
	watch: {
		'lessonPlanController.notesFontSize': {
			handler() {
				this.notesFontSize = this.lessonPlanController.notesFontSize
			}
		}
	}
}
</script>

<style scoped>
.notes-scroll-editor {
  overflow: auto;
  height: calc(100vh - 230px);
  position: relative;
  padding-left: 1px;
}
.notes-scroll-viewer {
  overflow: auto;
  height: calc(100vh - 192px);
  position: relative;
  padding-left: 1px;
}
.notes-scroll-viewer.presenter-mode {
  overflow: auto;
  height: calc(100vh - 56px);
}
.notes-scroll-viewer.presenter-mode p {
  padding: 15px 15px 0 15px;
  margin: 0;
  font-size: large;
  font-weight: 500;
}
.notes-scroll-viewer.presenter-mode .tiptap {
  max-height: unset !important;
}
</style>
